import { DestinationImage } from 'shared/api/MyTicketsModel.ts'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  data?: DestinationImage
}

export const CityImage = ({ data }: Props) => {
  if (!data?.image) return null

  return (
    <div className={s.container}>
      <ImageLazy
        src={data?.image}
        className={s.image}
      />
    </div>
  )
}
